
export const loginPage =
/** when your routing map is too long, you can split it into small modules **/
{
    path: '/login',
    name: 'login',
    component: () => import("@/views/login/login"),
}

export default loginPage



// WEBPACK FOOTER //
// ./src/router/modules/login.js